module.exports = __webpack_public_path__ + "img/annualization1.7e02b891.jpg";